module.exports = __webpack_public_path__ + "static/media/option-all-icon.a8ad68ca.svg";